import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarFull } from '../TopBarFull';
import {
  TopBarFullCtaColors,
  TopBarFullUseCaseEnums,
} from '../TopBarFullEnums';
import performanceImage from '../assets/UCS_Performance_Evaluation.png';

const DEFAULT_UTSOURCE2 = 'full_misc_upsell_performance_evaluation';
const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.headline',
    defaultMessage: 'Gauge performance with 360-degree evaluations',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.message',
    defaultMessage:
      'Start with our expert-certified performance evaluation template and customize as needed.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarFull.ctaText',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const INITIATED_DRAFTED_UTSOURCE2 =
  'full_initiate_upsell_performance_evaluation';
const INITIATED_DRAFTED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.headlineInitiated',
    defaultMessage: 'Gauge performance with 360-degree evaluations',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.messageInitiated',
    defaultMessage:
      'Start with our expert-certified performance evaluation template and customize as needed.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarFull.ctaTextInitiated',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const TESTED_ACTIVATED_UTSOURCE2 =
  'full_activate_upsell_performance_evaluation';
const TESTED_ACTIVATED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.headlineTested',
    defaultMessage: 'Track performance with recurring surveys',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.messageTested',
    defaultMessage: `Gather data over time. Pick a cadence and we'll send new survey links on your timeline.`,
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarFull.ctaTextTested',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

const DEPLOYED_UTSOURCE2 = 'full_deploy_upsell_performance_evaluation';
const DEPLOYED_COPY = defineMessages({
  HEADLINE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.headlineDeployed',
    defaultMessage: 'Share results easily with printable reports',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  MESSAGE: {
    id: 'UseCasePerformanceEvaluationTopBarFull.messageDeployed',
    defaultMessage:
      'Export and print performance evaluations for employees with upgraded plans.',
    description: '[Type: Paragraph][Vis.: low] - Top bar full message',
  },
  CTA_TEXT: {
    id: 'UseCasePerformanceEvaluationTopBarFull.ctaTextDeployed',
    defaultMessage: 'SEE ALL PLANS',
    description: '[Type: Button][Vis.: low] - Top bar full cta text',
  },
});

export type UseCasePerformanceEvaluationTopBarFullProps = {
  variation?: TopBarFullUseCaseEnums | null;
};

const VariationToCopy = {
  [TopBarFullUseCaseEnums.InitiatedDrafted]: {
    copy: INITIATED_DRAFTED_COPY,
    utSource2: INITIATED_DRAFTED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.TestedActivated]: {
    copy: TESTED_ACTIVATED_COPY,
    utSource2: TESTED_ACTIVATED_UTSOURCE2,
  },
  [TopBarFullUseCaseEnums.Deployed]: {
    copy: DEPLOYED_COPY,
    utSource2: DEPLOYED_UTSOURCE2,
  },
};

export const UseCasePerformanceEvaluationTopBarFull: React.FC<UseCasePerformanceEvaluationTopBarFullProps> = ({
  variation, //TODO: get this data.
}) => {
  const [copy, utSource2] =
    variation && variation in VariationToCopy
      ? [VariationToCopy[variation].copy, VariationToCopy[variation].utSource2]
      : [DEFAULT_COPY, DEFAULT_UTSOURCE2];
  return (
    <TopBarFull
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => <img src={performanceImage} aria-hidden="true" />}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL(`/pricing/upgrade`, {
        ut_source: 'topbar',
        ut_source2: utSource2,
      })}
      ctaNewTab={true}
      ctaColor={TopBarFullCtaColors.alt}
    />
  );
};

export default UseCasePerformanceEvaluationTopBarFull;
